import { render, staticRenderFns } from "./OtherNotice.vue?vue&type=template&id=2abe9935&scoped=true&"
import script from "./OtherNotice.vue?vue&type=script&lang=js&"
export * from "./OtherNotice.vue?vue&type=script&lang=js&"
import style0 from "./OtherNotice.vue?vue&type=style&index=0&id=2abe9935&lang=stylus&scoped=true&"
import style1 from "./OtherNotice.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abe9935",
  null
  
)

export default component.exports